import { render, staticRenderFns } from "./Page1.vue?vue&type=template&id=ae3402c0&scoped=true&"
import script from "./Page1.vue?vue&type=script&lang=js&"
export * from "./Page1.vue?vue&type=script&lang=js&"
import style0 from "./Page1.vue?vue&type=style&index=0&id=ae3402c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae3402c0",
  null
  
)

export default component.exports